import { MeetingTypeModel } from '../models/set-e-meeting/MeetingTypeModel';
import { MeetingWithAgendasModel } from '../models/set-e-meeting/MeetingWithAgendasModel';
import { authen_token, DIGITAL_FLOW_API } from './DigitalFlowBaseAPI';
import { AxiosResponse } from 'axios';

const getMeetingType = (): Promise<AxiosResponse<MeetingTypeModel[]>> => {
  return DIGITAL_FLOW_API.get<MeetingTypeModel[]>(`/set-e-meeting`, {
    headers: {
      Authorization: `Bearer ${authen_token}`,
    },
  });
};

const getMeetingByTypeCodeWithAgendas = (
  meetingTypeCode: string,
  isExclusive: boolean
): Promise<AxiosResponse<MeetingWithAgendasModel>> => {
  return DIGITAL_FLOW_API.get<MeetingWithAgendasModel>(
    `/set-e-meeting/meeting/by-type/${meetingTypeCode}/with-agendas`,
    {
      headers: {
        Authorization: `Bearer ${authen_token}`,
      },
      params: { isExclusive },
    }
  );
};

const downloadAgendaFile = (
  fileId: number
): Promise<AxiosResponse<any>> => {
  return DIGITAL_FLOW_API.get<any>(
    `/set-e-meeting/agenda-files/${fileId}/download/watermarked`,
    {
      headers: {
        Authorization: `Bearer ${authen_token}`,
      },
      responseType: 'blob',
    }
  );
};

export { getMeetingType, getMeetingByTypeCodeWithAgendas, downloadAgendaFile };
